import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useAgentSchedulerStateContext } from 'Context/NewAgentSchedulerContext';

const styles = (theme) => ({
  root: {
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    right: -49,
    width: 50,
    backgroundColor: theme.palette.facet.accentGray,
  },
  sidebarText: {
    position: 'absolute',
    top: '48%',
    left: 65,
    width: 70,
    textAlign: 'center',
    color: theme.palette.primary.main,
    ...theme.typography.body1,
  },
  countContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    fontWeight: 'bold',
  },
  lowMeetingCountColor: {
    color: theme.palette.facet.accentGreen2,
  },
  highMeetingCountColor: {
    color: theme.palette.facet.red,
  },
});

const SchedulerWeeklyCount = ({
  className,
  classes,
}) => {
  const { weeklyMeetingCountCollection } = useAgentSchedulerStateContext();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {weeklyMeetingCountCollection.resources().list().map((count) => (
        <div className={classNames(classes.countContainer, {
          [classes.lowMeetingCountColor]: Number(count.attr('count')) <= 20,
          [classes.highMeetingCountColor]: Number(count.attr('count')) > 20,
        })}
        >
          {count.attr('count')}
        </div>
      ))}
      <div className={classes.sidebarText}>
        Total Client Meetings
      </div>
    </Box>
  );
};

SchedulerWeeklyCount.defaultProps = {
  className: '',
};

SchedulerWeeklyCount.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SchedulerWeeklyCount);
